import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LearnCert } from '../../model/learn-cert/learn-cert';
import { LearnCertClassDTO } from '../../model/learn-cert/learn-cert-class-dto';
import { LearnCertDisableConfig } from '../../model/learn-cert/learn-cert-disable-config/learn-cert-disable-config';
import { NecUrl } from '../../model/url/url';
import { Observable } from 'rxjs';


@Injectable()
export class NecLearnCertInterface {

  constructor(private http: HttpClient) {
  }

  /**
   * è·åå­¦åç±»ååè¡¨
   */
  getLearnCertTypes(tenantId: number): Observable<any[]> {
    const params = new HttpParams().set('tenantId', tenantId + '');
    return this.http.get<LearnCertClassDTO[]>(NecUrl.SERVER_URL + '/mgt/learnCertTypes', { params: params });
  }

  /**
   * æ°å¢å­¦åé¡¹
   */
  addLearnCert(learnCert: LearnCert) {
    return this.http.post(NecUrl.SERVER_URL + '/mgt/learnCerts', learnCert);
  }

  /**
   * æ¹éæ°å¢å­¦åé¡¹
   */
  addLearnCerts(learnCert: LearnCert, number: number) {
    return this.http.post(NecUrl.SERVER_URL + '/mgt/learnCertAdds/' + number, learnCert);
  }

  /**
   * æ´æ°å­¦åé¡¹
   */
  updateLearnCert(id: number, learnCert: LearnCert) {
    return this.http.put(NecUrl.SERVER_URL + '/mgt/learnCerts/' + id, learnCert);
  }

  /**
   * æ¹éæäºå­¦å
   */
  grandLearnCerts(userIds: Array<number>, learnCertId: number) {
    let params = new HttpParams().set('learnCertId', learnCertId + '');
    return this.http.post(NecUrl.SERVER_URL + '/mgt/learnCertRecs', userIds, { params: params });
  }

  /**
   * è·åé¨é¨çå­¦ä¹ å­æ®ç¦ç¨æ°æ®
   */
  getLearnCertDisableConfigByDeptId(deptId: number): Observable<LearnCertDisableConfig> {
    return this.http.get<LearnCertDisableConfig>(NecUrl.SERVER_URL + '/mgt/learnCertDisableConfigs?deptId=' + deptId);
  }

  /**
   * è·åå°ç»çå­¦ä¹ å­æ®ç¦ç¨æ°æ®
   */
  getLearnCertDisableConfigByGroupId(groupId: number): Observable<LearnCertDisableConfig> {
    return this.http.get<LearnCertDisableConfig>(NecUrl.SERVER_URL + '/mgt/learnCertDisableConfigs?groupId=' + groupId);
  }
}
